<template  >
  <b-modal
    id="holidaysEvent-modal"
    ref="modal"
    title="Podgląd urlopu"
    hide-footer
    size="md"
  >
    <div class="d-flex justify-content-between mb-3">
      <h2>{{ event.title }}</h2>
      <h3>
        <label
          v-if="event.type === 'other'"
          class="badge badge-primary"
          >Inne</label
        >
        <label
          v-else-if="event.type === 'sickness'"
          class="badge badge-warning"
          >Chorobowe</label
        >
        <label
          v-else-if="event.type === 'holiday'"
          class="badge badge-success"
          >Urlop</label
        >
      </h3>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>Data rozpoczęcia:</span>
      <span>{{ event.start | date }}</span>
    </div>
    <div class="d-flex justify-content-between mb-2">
      <span>Data zakończenia:</span>
      <span>{{ event.end | date }}</span>
    </div>
    <div class="mt-4">
      <h5>Notatka:</h5>
      <p>{{ event.description }}</p>
    </div>
    <template v-if="isAdmin">
      <hr />
      <div class="d-flex justify-content-end align-items-center">
        <div>
          <button
            class="btn btn-outline-primary mr-2"
            v-on:click="edit"
          >
            Edytuj
          </button>
          <button
            class="btn btn-outline-danger"
            v-on:click="remove"
          >
            <i class="fas fa-trash-alt"></i> Usuń
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import HolidaysService from "@/services/holidays.service";
import dayjs from "dayjs";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "ModalHolidaysEvent",
  components: {},
  props: {
    event: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  computed: {
    ...mapGetters("user", ["isAdmin"]),
  },
  methods: {
    edit() {
      this.$emit("onEdit", true);
      this.$nextTick(() => {
        this.$bvModal.hide("holidaysEvent-modal");
      });
    },
    remove() {
      this.$bvModal;
      var h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy na pewno chcesz usunąć urlop użytkownika ",
              h("br"),
              h("br"),
              h("strong", this.event.title),
              " z dni ",
              h("strong", dayjs(this.event.start).format("YYYY-MM-DD")),
              " - ",
              h("strong", dayjs(this.event.end).format("YYYY-MM-DD")),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie urlopu",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          HolidaysService.delete(this.event.id).then(() => {
            this.$emit("onRemove", this.event.id);
            this.$nextTick(() => {
              this.$bvModal.hide("holidaysEvent-modal");
            });
          });
        });
    },
  },
};
</script>
